import React from "react";

import Background from "../../../assets/cleaning/cleaning-bg-02.png";
import Image from "../../../assets/cleaning/cleaning-choice-a.png";

import GamePageLayout from "../GamePageLayout";

const CleaningPage3 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      img={Image}
      onClickNext={() => setCurrentPage("weekend")}
    >
      1회용 청소포는
      <br />
      너무 쓰레기가 많이 나와.
      <br />
      번거롭더라도
      <br />
      걸레로 청소하자.
    </GamePageLayout>
  );
};

export default CleaningPage3;
